import { render, staticRenderFns } from "./formMap.vue?vue&type=template&id=4c0cc896&scoped=true"
import script from "./formMap.vue?vue&type=script&lang=js"
export * from "./formMap.vue?vue&type=script&lang=js"
import style0 from "./formMap.vue?vue&type=style&index=0&id=4c0cc896&prod&lang=css"
import style1 from "./formMap.vue?vue&type=style&index=1&id=4c0cc896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0cc896",
  null
  
)

export default component.exports